import { render, staticRenderFns } from "./Exporters.vue?vue&type=template&id=89e50a56"
import script from "./Exporters.vue?vue&type=script&lang=js"
export * from "./Exporters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports